module.exports = __webpack_public_path__ + "img/_1.48fbbf52.png";